const styles = {
  container: {
    border: 0,
    height: "40px",
    width: "40px",
    padding: "5px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    cursor: "pointer",
    zIndex: "800",

    "@media screen and (max-width : 1200px)": {
      right: "65px",
      marginBottom: "0px",
    },
  },
};

export default styles;
